$('ul.nav li:nth-child(2) a').addClass('active');